const BorderWeightIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <rect
        x="2.08301"
        y="14.582"
        width="2.5"
        height="11.8333"
        rx="1.25"
        transform="rotate(-90 2.08301 14.582)"
        stroke="#0C172C"
        strokeWidth="1.5"
      />

      <rect
        x="2.75"
        y="9.25"
        width="2.5"
        height="10.5"
        rx="1.25"
        transform="rotate(-90 2.75 9.25)"
        stroke="#0C172C"
        strokeWidth="1.5"
      />

      <rect
        x="3.41699"
        y="3.91797"
        width="2.5"
        height="9.16667"
        rx="1.25"
        transform="rotate(-90 3.41699 3.91797)"
        stroke="#0C172C"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default BorderWeightIcon;
